module.exports = new __parcel__URL__("balloons.8acbde79.svg").toString();